var hu = {
	"neptune.Button.loadingAriaLabel": "betöltés",
	"neptune.Chips.ariaLabel": "{choice} törlése",
	"neptune.ClearButton.ariaLabel": "Törlés",
	"neptune.CloseButton.ariaLabel": "Bezárás",
	"neptune.DateInput.day.label": "Nap",
	"neptune.DateInput.day.placeholder": "NN",
	"neptune.DateInput.month.label": "Hónap",
	"neptune.DateInput.year.label": "Év",
	"neptune.DateInput.year.placeholder": "ÉÉÉÉ",
	"neptune.DateLookup.day": "nap",
	"neptune.DateLookup.goTo20YearView": "Ugrás a 20 éves nézetre",
	"neptune.DateLookup.month": "hónap",
	"neptune.DateLookup.next": "következő",
	"neptune.DateLookup.previous": "előző",
	"neptune.DateLookup.selected": "kiválasztva",
	"neptune.DateLookup.twentyYears": "20 év",
	"neptune.DateLookup.year": "év",
	"neptune.FlowNavigation.back": "vissza az előző lépéshez",
	"neptune.Info.ariaLabel": "További információ",
	"neptune.Label.optional": "(Válaszható)",
	"neptune.Link.opensInNewTab": "(új lapon nyílik meg)",
	"neptune.MoneyInput.Select.placeholder": "Válassz ki egy lehetőséget...",
	"neptune.MoneyInput.Select.selectCurrencyLabel": "Pénznem kiválasztása",
	"neptune.PhoneNumberInput.SelectInput.placeholder": "Válassz ki egy lehetőséget...",
	"neptune.Select.searchPlaceholder": "Keresés...",
	"neptune.SelectInput.noResultsFound": "Nincs találat",
	"neptune.SelectOption.action.label": "Kiválasztás",
	"neptune.SelectOption.selected.action.label": "Kiválasztott opció módosítása",
	"neptune.StatusIcon.iconLabel.error": "Hiba:",
	"neptune.StatusIcon.iconLabel.information": "Információ:",
	"neptune.StatusIcon.iconLabel.pending": "Függőben:",
	"neptune.StatusIcon.iconLabel.success": "Siker:",
	"neptune.StatusIcon.iconLabel.warning": "Figyelmeztetés:",
	"neptune.Summary.statusDone": "Kész",
	"neptune.Summary.statusNotDone": "Hátravan",
	"neptune.Summary.statusPending": "Függőben",
	"neptune.Table.actionHeader": "Művelet",
	"neptune.Table.emptyData": "Nincs találat",
	"neptune.Table.loaded": "Táblázatadatok betöltve",
	"neptune.Table.loading": "Táblázatadatok betöltése folyamatban",
	"neptune.Table.refreshPage": "Oldal frissítése",
	"neptune.Upload.csButtonText": "Másik fájl feltöltése?",
	"neptune.Upload.csFailureText": "Feltöltés sikertelen. Kérünk, próbáld újra",
	"neptune.Upload.csSuccessText": "Feltöltés sikeres",
	"neptune.Upload.csTooLargeMessage": "Kérünk, olyan fájlt küldj el, amely kisebb mint {maxSize}MB",
	"neptune.Upload.csWrongTypeMessage": "Nem támogatott fájltípus. Kérünk, próbáld újra másik fájllal",
	"neptune.Upload.psButtonText": "Mégsem",
	"neptune.Upload.psProcessingText": "Feltöltés...",
	"neptune.Upload.retry": "Újra",
	"neptune.Upload.usButtonText": "Vagy válaszd ki a fájlt",
	"neptune.Upload.usDropMessage": "Húzd ide a fájlokat a feltöltéshez",
	"neptune.Upload.usPlaceholder": "Húzz ide egy legfeljebb {maxSize}MB méretű fájlt",
	"neptune.UploadButton.allFileTypes": "Összes fájltípus",
	"neptune.UploadButton.dropFiles": "Húzd a fájlokat ide a feltöltéshez",
	"neptune.UploadButton.instructions": "{fileTypes}, legfeljebb {size}MB",
	"neptune.UploadButton.maximumFiles": "Maximum {maxFiles} fájl.",
	"neptune.UploadButton.uploadFile": "Fájl feltöltése",
	"neptune.UploadButton.uploadFiles": "Fájlok feltöltése",
	"neptune.UploadInput.deleteModalBody": "Ha törlöd ezt a fájlt, azzal a rendszerünkből is eltávolítod.",
	"neptune.UploadInput.deleteModalCancelButtonText": "Mégsem",
	"neptune.UploadInput.deleteModalConfirmButtonText": "Eltávolítás",
	"neptune.UploadInput.deleteModalTitle": "Biztosan törölni szeretnéd ezt a fájlt?",
	"neptune.UploadInput.fileIsTooLarge": "A fájl túl nagy",
	"neptune.UploadInput.fileTypeNotSupported": "Nem támogatott fájltípus",
	"neptune.UploadInput.maximumFilesAlreadyUploaded": "Sajnos ez a feltöltés sikertelen volt, mert csak {maxFilesAllowed} fájlt tudunk egyszerre elfogadni.",
	"neptune.UploadItem.deleting": "Törlés...",
	"neptune.UploadItem.removeFile": "{filename} fájl törlése",
	"neptune.UploadItem.uploaded": "Feltöltve",
	"neptune.UploadItem.uploadedFile": "Feltöltött fájl",
	"neptune.UploadItem.uploading": "Feltöltés...",
	"neptune.UploadItem.uploadingFailed": "Feltöltés sikertelen"
};

export { hu as default };
//# sourceMappingURL=hu.json.mjs.map
